{
  "FormEngineSessionLogWfl": {
    "title": "Sitzungsprotokoll",
    "description": "Erstellen Sie eine Momentaufnahme des aktuellen Status des Formulars",
    "retention": "Speicherung (Tage)"
  }
}